import React from 'react';
import LinkButton from '|/components/carvana-ds/link-button';
import VehicleImage from '|/components/vehicle-image';
import type { VehicleCardProps } from './types';
import { financeTotalLabel, formatCurrency, getNonFinanceLabel } from './vehicle-card-helpers';
import styles from './vehicle-card.module.css';

const VehicleCard: React.FC<VehicleCardProps> = ({ summary, onViewOrderDetails }) => {
  const { stockNumber, year, make, model, trim, purchaseType, monthlyPayment, cashDue } = summary;

  const totalDisplay =
    purchaseType === 'finance' ? financeTotalLabel(cashDue ?? 0) : getNonFinanceLabel(summary);

  return (
    <div className={styles.card} data-testid="pp_checkout_vehicle-card">
      <div className={styles.content}>
        <div className={styles.mediaWrap}>
          <VehicleImage
            stockNumber={stockNumber}
            width={800}
            variant="desktop"
            alt={`${year} ${make} ${model}`}
            className={styles.media}
          />
        </div>

        <div className={styles.info}>
          <div className={styles.ymmt}>
            <p className={styles.vehicleName}>
              {year} {make} {model}
            </p>
            <p className={styles.trimText}>{trim}</p>
          </div>

          <div className={styles.priceDetails}>
            <div className={styles.purchaseStats}>
              {purchaseType === 'finance' && (
                <div className={styles.statStacked}>
                  <span className={styles.statStackedLabel}>Payment</span>
                  <div className={styles.statStackedAmountInline}>
                    <span className={styles.statStackedAmount}>
                      {formatCurrency(monthlyPayment ?? 0)}
                    </span>
                    <span className={styles.statStackedAmountSuffix}>/mo</span>
                  </div>
                </div>
              )}
              <div className={styles.statStacked}>
                <span className={styles.statStackedLabel}>{totalDisplay.label}</span>
                <span className={styles.statStackedAmount}>
                  {formatCurrency(totalDisplay.amount)}
                </span>
              </div>
            </div>
            <LinkButton
              className={styles.priceDetailsButton}
              size="sm"
              underline={false}
              onClick={onViewOrderDetails}
              data-analytics-id="checkout-vehicle-card-review-order"
              data-testid="pp_checkout_vehicle-card_price-details"
            >
              Price details
            </LinkButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VehicleCard;
